import InputDatePicker from './InputDatePicker.component';

export default InputDatePicker;
